import { Bar } from "vue-chartjs";
import merge from "lodash/merge";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";

export default {
  name: "BarChart",
  extends: Bar,
  props: {
    data: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      barChartDefaultOptions: {
        scales: {
          yAxes: [
            {
              gridLines: {
                display: true,
                drawBorder: false
              },
              ticks: {
                display: true,
                fontSize: 16,
                fontFamily: "Montserrat",
                fontColor: "#c3c5cd",
                padding: 8,
                beginAtZero: true
              },
              display: true
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
              offset: true,
              display: true,
              type: "time",
              distribution: "series",
              ticks: {
                display: true,
                fontFamily: "Montserrat",
                fontColor: "#4a4f66",
                padding: 10
              }
            }
          ]
        },
        tooltip: {
          enabled: true
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.$emit("loadingChartStatus", true);
    this.render();
  },
  watch: {
    labels: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    },
    data: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    }
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.data
        },
        merge(this.barChartDefaultOptions, this.options)
      );
    }
  }
};
